import React, { useState, useEffect, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Breadcrumbs } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import queryString from "query-string";
import theme from "../../theme";
import CommonButton from "../button";
import CommonDropDown from "../dropdown";
import CommonInput from "../input";
import CompanyEmployeeDetail from "./detail";
import InviteEmployees from "./inviteEmployees";
import BulkUpdateEmployees from "./bulkUpdateEmployees";
import EmployeeDetail from "./employeeDetail";
import EditEmployeeDetail from "./editEmployeeDetail";
import SearchEmployee from "./searchEmployee";
import { getEmployeeListAction } from "../../containers/dashboard/action";
import {
  updateEmployeeAction,
  createPayStackProfileAction,
  invitePendingEmployeesAction,
  invitePendingEmployeesErrorAction,
  invitePendingEmployeesSuccessAction,
  inviteCompanyAdminAction,
  inviteCompanyAdminSuccessAction,
  inviteCompanyAdminErrorAction,
} from "../../containers/companyDashboard/action";
import InviteAdminForm from "../forms/inviteAdminForm";
import { getDeductionListAction } from "../../containers/employeeConfirmRegistration/action";
import { enqueueSnackbar } from 'notistack'
import history from "../../history";

let employeeOptions = [];
let employeeOptionsWithId = [];

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: theme.colors.White,
    width: "100%",
    minHeight: "calc(100vh - 175px)",
    padding: "45px 90px",
    marginLeft: "220px",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "& .title": {
      color: theme.colors.Violet,
      fontFamily: theme.fontFamily.MARKPROMEDIUM,
      fontSize: "24px",
      "& .companyLabel": { color: "#9FC1FD", cursor: "pointer" },
      "& .companyNameLabel": {
        color: theme.colors.DodgerBlue,
        cursor: "pointer",
      },
    },
  },
  select: {
    padding: "8px 12px",
    borderRadius: "8px",
    border: "1px solid #D1D5DB",
    fontSize: "14px",
    fontWeight: "500",
    width: "200px",
    fontFamily: theme.fontFamily.MARKPROMEDIUM,
    background: theme.colors.Zumthor,
    color: theme.colors.Violet,
    marginLeft: "3px",
    outline: "none",
    '&:hover': {
      borderColor: theme.colors.Zumthor,
    },
    '&:focus': {
      borderColor: "#10B981",
    },
  },
  searchGroup: {
    padding: "0px",
    marginTop: "16px"
  },
  backLink: {
    marginTop: "15px",
    color: theme.colors.DodgerBlueLight,
    fontSize: "16px",
    fontFamily: theme.fontFamily.MARKPROMEDIUM,
    cursor: "pointer",
    alignItems: "center",
    display: "flex",
    "& .label": { marginLeft: "5px", position: "relative", top: 2 },
  },
  filterContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    marginTop: "15px",
    marginBottom: "15px",
    float: "right",
    "& .title": {
      color: theme.colors.DodgerBlue,
      fontSize: "16px",
      fontFamily: theme.fontFamily.MARKPROMEDIUM,
      marginRight: 20,
    },
  },
  searchInput: {
    marginTop: "5px",
    borderRadius: "8px",
  }
}));

function Employees({ location }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const getEmployeeListMethod = useCallback(
    (data) => dispatch(getEmployeeListAction(data)),
    [dispatch]
  );

  const updateEmployeeMethod = useCallback(
    (data, employee_id, employee_state) => dispatch(updateEmployeeAction(data, employee_id, employee_state)),
    [dispatch]
  );

  const createPayStackProfileActionMethod = useCallback(
    (data) => dispatch(createPayStackProfileAction(data)),
    [dispatch]
  );

  const invitePendingEmployeesMethod = useCallback(
    (data) => dispatch(invitePendingEmployeesAction(data)),
    [dispatch]
  );

  const invitePendingEmployeesSuccessMethod = useCallback(
    (data) => dispatch(invitePendingEmployeesSuccessAction(data)),
    [dispatch]
  );

  const invitePendingEmployeesErrorMethod = useCallback(
    (error) => dispatch(invitePendingEmployeesErrorAction(error)),
    [dispatch]
  );
  const inviteCompanyAdminMethod = useCallback(
    (data) => dispatch(inviteCompanyAdminAction(data)),
    [dispatch]
  );
  const inviteCompanyAdminSuccessMethod = useCallback(
    (data) => dispatch(inviteCompanyAdminSuccessAction(data)),
    [dispatch]
  );
  const inviteCompanyAdminErrorMethod = useCallback(
    (error) => dispatch(inviteCompanyAdminErrorAction(error)),
    [dispatch]
  );

  const getDeductionListMethod = useCallback(
    () => dispatch(getDeductionListAction()),
    [dispatch]
  );

  const loginReducer = useSelector((state) => {
    return state.loginReducer;
  });
  const dashboardReducer = useSelector((state) => {
    return state.dashboardReducer;
  });
  const companyDashboardReducer = useSelector((state) => {
    return state.companyDashboardReducer;
  });
  const employeeRegistrationReducer = useSelector((state) => {
    return state.employeeRegistrationReducer;
  });

  const [inviteEmployees, setInviteEmployees] = useState(false);
  const [bulkUpdateEmployees, setBulkUpdateEmployees] = useState(false);
  const [employeeDetail, setEmployeeDetail] = useState(null);
  const [editEmployeeDetail, setEditEmployeeDetail] = useState(null);
  const [searchEmployee, setSearchEmployee] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employeeState, setEmployeeState] = useState("BOARDED");
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [showInviteAdminForm, setShowInviteAdminForm] = useState(false);
  const user = JSON.parse(localStorage.user);

  useEffect(() => {
    if (location?.search) {
      const parsed = queryString.parse(location.search);
      if (parsed?.employeeId) {
        if (
          dashboardReducer?.employeeList?.data?.length &&
          (!employeeDetail?.id || employeeDetail.id !== parsed.employeeId)
        ) {
          const record = dashboardReducer?.employeeList?.data.find(
            (each) => each?.id === parsed?.employeeId
          );
          if (record) {
            setEmployeeDetail(record);
            setSearchEmployee(false);
          } else {
            setEmployeeDetail(null);
          }
        }
      } else {
        setEmployeeDetail(null);
      }
    } else {
      setEmployeeDetail(null);
    }
  }, [location, dashboardReducer, employeeDetail]);

  useEffect(() => {
    getDeductionListMethod();
  }, [getDeductionListMethod]);

  useEffect(() => {
    if (
      companyDashboardReducer?.updateEmployeeSuccess &&
      loginReducer?.companyInformation?.id
    ) {
      getEmployeeListMethod({
        company_id: loginReducer.companyInformation.id,
      });
    }
  }, [
    companyDashboardReducer,
    setEditEmployeeDetail,
    loginReducer,
    getEmployeeListMethod,
  ]);

  useEffect(() => {
    if (loginReducer?.companyInformation?.id) {
      getEmployeeListMethod({
        company_id: loginReducer.companyInformation.id,
      });
    }
  }, [loginReducer, getEmployeeListMethod]);

  useEffect(() => {
    if (dashboardReducer?.employeeList?.data?.length) {
      for (let i = 0; i < dashboardReducer.employeeList.data.length; i++) {
        const each = dashboardReducer.employeeList.data[i];
        if (employeeOptions.findIndex((rec) => rec.value === each.id) < 0)
          employeeOptions.push({
            value: each.id,
            label: `${each?.first_name} ${each?.last_name}`,
          });
        if ((employeeOptionsWithId.findIndex((rec) => rec.value === each.id) < 0) && each.employee_id)
          employeeOptionsWithId.push({
            value: each.id,
            label: `${each.employee_id}`,
          });
      }
    }
  }, [dashboardReducer]);

  useEffect(() => {
    if (companyDashboardReducer?.invitePendingEmployeesSuccess) {
      enqueueSnackbar("Invite sent to all pending employees", { variant: "success", onClose: () => { invitePendingEmployeesSuccessMethod(null) } })
    }
    if (companyDashboardReducer?.invitePendingEmployeesError) {
      if (Array.isArray(companyDashboardReducer?.invitePendingEmployeesError)) {
        companyDashboardReducer?.invitePendingEmployeesError.forEach((error) => {
          enqueueSnackbar(error, { variant: "error", onClose: () => { invitePendingEmployeesErrorMethod(null) } })
        })
      } else if (typeof companyDashboardReducer?.invitePendingEmployeesError === "string") {
        enqueueSnackbar(companyDashboardReducer?.invitePendingEmployeesError, { variant: "error", onClose: () => { invitePendingEmployeesErrorMethod(null) } })
      } else {
        enqueueSnackbar("Error inviting pending employees", { variant: "error", onClose: () => { invitePendingEmployeesErrorMethod(null) } })
      }
    }
  }, [companyDashboardReducer?.invitePendingEmployeesSuccess, companyDashboardReducer?.invitePendingEmployeesError])

  useEffect(() => {
    if (companyDashboardReducer?.inviteCompanyAdminSuccess) {
      enqueueSnackbar("Invite sent to company admin", { variant: "success", onClose: () => { inviteCompanyAdminSuccessMethod(null) } })
    }
    if (companyDashboardReducer?.inviteCompanyAdminError) {
      if (Array.isArray(companyDashboardReducer?.inviteCompanyAdminError)) {
        companyDashboardReducer?.inviteCompanyAdminError.forEach((error) => {
          enqueueSnackbar(error, { variant: "error", onClose: () => { inviteCompanyAdminErrorMethod(null) } })
        })
      } else if (typeof companyDashboardReducer?.inviteCompanyAdminError === "string") {
        enqueueSnackbar(companyDashboardReducer?.inviteCompanyAdminError, { variant: "error", onClose: () => { inviteCompanyAdminErrorMethod(null) } })
      } else {
        enqueueSnackbar("Error inviting company admin", { variant: "error", onClose: () => { inviteCompanyAdminErrorMethod(null) } })
      }
    }
  }, [companyDashboardReducer?.inviteCompanyAdminSuccess, companyDashboardReducer?.inviteCompanyAdminError])

  return (
    <div className={classes.root}>
      <div className={classes.headerContainer}>
        <div className="title">
          <div>
            {inviteEmployees
              ? "Invite Employees"
              : bulkUpdateEmployees
                ? "Bulk Update Employees"
                : editEmployeeDetail
                  ? "Edit Employee Details"
                  : "Employees"}
          </div>
          {employeeDetail && !editEmployeeDetail ? (
            <div style={{ marginTop: "15px" }}>
              <Breadcrumbs
                separator={
                  <NavigateNextIcon
                    fontSize="small"
                    style={{ color: "#9FC1FD" }}
                  />
                }
              >
                <div
                  className="companyLabel"
                  onClick={() => {
                    history.push("/company/dashboard/Employees");
                  }}
                >
                  Employees
                </div>
                <div className="companyNameLabel">
                  {employeeDetail?.first_name} {employeeDetail?.last_name}
                </div>
              </Breadcrumbs>
            </div>
          ) : null}
          {inviteEmployees ||
            bulkUpdateEmployees ||
            editEmployeeDetail ||
            (searchEmployee && !employeeDetail) ? (
            <div
              className={classes.backLink}
              onClick={() => {
                setInviteEmployees(false);
                setBulkUpdateEmployees(false)
                setEditEmployeeDetail(null);
                setSearchEmployee(false);
                setSelectedEmployee(null);
                if (editEmployeeDetail) {
                  history.push(
                    `/company/dashboard/Employees?employeeId=${editEmployeeDetail?.id}`
                  );
                } else {
                  history.push("/company/dashboard/Employees");
                }
              }}
            >
              <img src="/images/right-arrow.png" alt="right-arrow" />
              <span className="label">Back</span>
            </div>
          ) : null}
        </div>
        <>
          {user.is_admin &&
            <>

              {!(inviteEmployees || bulkUpdateEmployees || employeeDetail || searchEmployee) ? (

                <div style={{ display: "flex", gap: "10px" }}>
                  <CommonButton
                    type="button"
                    text="Bulk Update Employees"
                    stylevariant="primary"
                    onClick={() => {
                      setBulkUpdateEmployees(true);
                    }}
                    style={{ padding: "5px 20px" }}
                    fontSize="15px"
                    fontFamily={theme.fontFamily.MARKPROHEAVY}
                  />
                  <CommonButton
                    type="button"
                    text="Invite Employees"
                    stylevariant="primary"
                    onClick={() => {
                      setInviteEmployees(true);
                    }}
                    style={{ padding: "5px 20px" }}
                    fontSize="15px"
                    fontFamily={theme.fontFamily.MARKPROHEAVY}
                />
                <CommonButton
                    type="button"
                    text="Invite Admin"
                    stylevariant="primary"
                    onClick={() => {
                      setShowInviteAdminForm(true);
                    }}
                    style={{ padding: "5px 20px" }}
                    fontSize="15px"
                    fontFamily={theme.fontFamily.MARKPROHEAVY}
                />
                
                  <CommonButton
                    type="button"
                    text="Invite All Pending Employees"
                    stylevariant="primary"
                    onClick={() => {
                      invitePendingEmployeesMethod({});
                    }}
                    disabled={companyDashboardReducer?.loading}
                    loading={companyDashboardReducer?.loading}
                    style={{ padding: "5px 20px" }}
                    fontSize="15px"
                    fontFamily={theme.fontFamily.MARKPROHEAVY}
                  />
                </div>
              ) : searchEmployee && !employeeDetail ? (
                <div className={`${classes.filterContainer}`}>
                  <div className="title">Search by</div>
                  <div
                    style={{ width: "200px" }}
                    onClick={() => {
                      setSearchEmployee(true);
                    }}
                    className={classes.searchGroup}
                  >
                    <CommonInput
                      placeholder={"Search Employee"}
                      value={selectedEmployee}
                      onChange={(e) => {
                        setSelectedEmployee(e.target.value);
                      }}
                      className={classes.searchInput}
                    />
                  </div>
                  <select
                    onChange={(e) => { setEmployeeState(e.target.value) }}
                    className={classes.select}
                  >
                    <option value={"BOARDED"}>Boarded</option>
                    <option value={"PENDING"}>Pending</option>
                  </select>
                  <div
                    style={{ width: "200px" }}
                    onClick={() => {
                      setSearchEmployee(true);
                    }}
                    className={classes.searchGroup}
                  >
                    <CommonDropDown
                      placeholder={"Search Emp Id"}
                      options={employeeOptionsWithId}
                      value={selectedEmployeeId}
                      onChange={(value) => {
                        setSelectedEmployeeId(value);
                      }}
                    />
                  </div>
                </div>
              ) : null}
            </>
          }
        </>
      </div>
      <InviteAdminForm
        open={showInviteAdminForm}
        onClose={() => setShowInviteAdminForm(false)}
        onInvite={(submittedData) => {
          inviteCompanyAdminMethod({
            email: submittedData.email,
            is_admin: submittedData?.permission?.toLowerCase() === "admin",
            is_hr: submittedData?.permission?.toLowerCase() === "hr",
          });
      }} />
      {searchEmployee ? (
        <SearchEmployee
          selectedEmployee={selectedEmployee}
          employeeState={employeeState}
          updateEmployeeMethod={updateEmployeeMethod}
          selectedEmployeeId={selectedEmployeeId}
        />
      ) : inviteEmployees ? (
        <InviteEmployees setInviteEmployees={setInviteEmployees} />
      ) : bulkUpdateEmployees ? (
        <BulkUpdateEmployees setBulkEmployees={setBulkUpdateEmployees} />
      )
        : editEmployeeDetail ? (
          <EditEmployeeDetail
            editEmployeeDetail={editEmployeeDetail}
            setEditEmployeeDetail={setEditEmployeeDetail}
            updateEmployeeMethod={updateEmployeeMethod}
            deductionList={employeeRegistrationReducer?.deductionList}
          />
        ) : employeeDetail ? (
          <EmployeeDetail
            setEditEmployeeDetail={setEditEmployeeDetail}
            employeeDetail={employeeDetail}
            updateEmployeeMethod={updateEmployeeMethod}
            createPayStackProfileActionMethod={createPayStackProfileActionMethod}
          />
        ) : (
          <CompanyEmployeeDetail
            setSearchEmployee={setSearchEmployee}
            updateEmployeeMethod={updateEmployeeMethod}
          />
        )}
    </div>
  );
}

export default Employees;
